import { useTheme } from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";
import { withFetch } from "@ui-components/data-fetcher/DataFetcher.tsx";

import { ClaimStatusBadgeBaseProps } from "./ClaimStatusBadge.types.ts";
import { ClaimStatusCompactBadge } from "./ClaimStatusCompactBadge.tsx";
import { ClaimStatusIconBadge } from "./ClaimStatusIconBadge.tsx";
import { ClaimStatusStandardBadge } from "./ClaimStatusStandardBadge.tsx";
import { mapToClaimBadgeProps } from "./utils.tsx";

const ClaimStatusBadgeBase: React.FC<ClaimStatusBadgeBaseProps> = props => {
  const { acc } = useStores();
  const theme = useTheme();

  const mappedProps = props.mapToBadgeProps
    ? props.mapToBadgeProps(props, theme, acc)
    : mapToClaimBadgeProps(props, theme, acc);

  if (props.compactMode) {
    return (
      <ClaimStatusCompactBadge
        {...mappedProps}
        compactMode={props.compactMode}
        claimId={props.claimId}
      />
    );
  }

  if (mappedProps.displayIcon) {
    return <ClaimStatusIconBadge {...mappedProps} />;
  }

  return <ClaimStatusStandardBadge {...mappedProps} />;
};

export const ClaimStatusBadge = withFetch(
  x => [
    x.acc.ref.claimStatuses.load(),
    x.acc.ref.claimAdjustmentStatuses.load()
  ],
  ClaimStatusBadgeBase
);
